import styled from "styled-components";

export const ModalContainer = styled.div`
  background-color: #fff;
  width: 40rem;
  border-radius: 1rem;
  height: 90%;
  position: relative;
`

export const CloseModal = styled.div`
  position: absolute;
  top: 0;
  right: -3rem;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #f4f4f4;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
`

export const CloseButton = styled.div`
  background-color: #fff;
  width: 2rem;
  height: 2rem;
  position: absolute;
  right: 0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DownloadButton = styled.div`
  position: absolute;
  top: .8rem;
  right: .8rem;
  width: 1.2rem;
  z-index: 1;
  cursor: pointer;
  img{
    width: 100%;
    filter: grayscale(1);
    :hover{
      filter: grayscale(0);
    }
  }
`

export const DocumentContainer = styled.div`
  overflow: auto;
  position: relative;
  height: 100%;
  padding: 1.8rem;
`

export const StructuresContainer = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column-reverse;
  gap:1rem;
  margin-top: 2rem;
`

export const Structures = styled.div`
  background-color: #f4f4f4;
  border-radius: 1rem;
  padding: 1rem 1rem 2rem 1rem;
`

export const StructureName = styled.h1`
  font-size: 15px;
  border-radius: .5rem;
  padding: 10px 5px;
`

export const HeacerDoc = styled.div`
  img{
    width: 10rem;
  }
`